import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';

export default function ImpersonationBanner({ user, onStopImpersonation }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [stopping, setStopping] = useState(false);

  const isAdminRoute = location.pathname.startsWith('/admin');

  if (!user?.impersonation_active || isAdminRoute) {
    return null;
  }

  const handleStop = async () => {
    setStopping(true);
    try {
      await onStopImpersonation();
      toast.success('Você voltou para o painel admin.');
      navigate('/admin/painel');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Não foi possível encerrar a impersonação.');
      setStopping(false);
    }
  };

  return (
    <div className="bg-[#FFF4E8] border-b border-[#E6C7A0] px-4 py-3">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="rounded-full bg-[#C88A3D]/15 p-2 text-[#A76418]">
            <ShieldAlert className="h-4 w-4" />
          </div>
          <div className="text-sm text-[#6E4A1F]">
            <p className="font-semibold">Modo suporte ativo</p>
            <p>
              Você está visualizando a conta de <strong>{user.name || user.email}</strong>
              {user.impersonated_by_admin_name ? ` como ${user.impersonated_by_admin_name}` : ''}.
            </p>
          </div>
        </div>
        <Button
          type="button"
          variant="outline"
          onClick={handleStop}
          disabled={stopping}
          className="border-[#C88A3D] bg-white text-[#A76418] hover:bg-[#FFF8F0]"
        >
          {stopping ? 'Saindo...' : 'Voltar ao admin'}
        </Button>
      </div>
    </div>
  );
}
